import { clsx } from 'clsx';
import { Sheet } from 'react-modal-sheet';
import { BottomSheetProps } from './BottomSheet';

export const BottomSheet = ({
  children,
  onClose,
  snapPoints,
  isOpen = true,
  backgroundColor,
  dismissable = true,
  initialSnapPosition = undefined,
  footerContent,
  blurEnabled = false,
  detent = "content-height"
}: BottomSheetProps) => {
  const snaps = snapPoints
    ?.map(s => (typeof s == 'string' ? percentageToRatio(s) : s))
    ?.sort();

  return (
    <Sheet
      isOpen={isOpen}
      onClose={() => onClose?.()}
      detent={detent}
      disableDrag={!dismissable}
      snapPoints={snaps}
      initialSnap={initialSnapPosition}>
      <Sheet.Container className="rounded-t-lg" style={{ backgroundColor }}>
        <Sheet.Header />
        <Sheet.Content>
          <div className="max-h-screen flex flex-col z-50">
            {children} {footerContent}
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop
        className={clsx({ 'backdrop-blur-sm z-50': blurEnabled })}
      />
    </Sheet>
  );
};

function percentageToRatio(percentage: string) {
  return (
    Number.parseFloat(percentage.substring(0, percentage.length - 1)) / 100
  );
}
